var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkSolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #02222b;\n      }\n\n      .cls-2 {\n        fill: #2fe0e6;\n      }\n\n      .cls-3 {\n        stroke-width: 1.4px;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: #2fe0e6;\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: none;\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        stroke-width: 4px;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.7,24.4c-11.2,0-20.7,9.4-20.7,20.7v2.9h40.7v-2.9c.6-11.8-8.9-20.7-20-20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78,44.9h7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.7,44.9h7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.8,64.5l5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.4,19l5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.7,64.5l-5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75,19l-5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.7,72.7v7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.7,9v7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.7,91H3.7l13.6-21.2,9.4-14.7h47.2l9.4,14.7s12.4,21.2,12.4,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.7,55.1v35.9M49.7,55.1h11.8M49.7,55.1h-11.8M49.7,91h46.6l-13.6-21.2M49.7,91h-23M61.5,55.1h11.8l9.4,14.7M61.5,55.1l11.8,35.9M37.9,55.1h-11.2l-9.4,14.7M37.9,55.1l-11.8,35.9M26.7,91H3.7l13.6-21.2M82.7,69.8H17.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSolar);
export default __webpack_public_path__ + "static/media/dark-solar.0e021d49dbcd4b601b0428b476d739f3.svg";
export { ForwardRef as ReactComponent };